export const mainNavigation = [
  ['How We Help', '/how-we-help'],
  ['How It Works', '/how-it-works'],
  ['Consultation & Fees', '/pricing'],
  ['About', '/about'],
  ['News', '/news'],
  ['FAQ', '/faq'],
] as const
